import { FC } from "react";
import { ListItem, ListItemPrefix } from "../material-old";
import { Tooltip } from "antd";
import { SidebarItemProps } from "./types.ts";
import { useAppSelector } from "../../redux/hooks.ts";
import {
  adminItems,
  validatedItems,
} from "./fixtures/sidebarProtectedItems.tsx";
import { Link } from "react-router-dom";
import "../../styles/components/navigation/SidebarItem.scss";

export const SidebarItem: FC<SidebarItemProps> = ({
  icon,
  label,
  href,
  active,
  mobile,
}) => {
  const activeClasses = active ? "item-active" : "item-inactive";
  const activeMobileClasses = active
    ? "item-mobile-active"
    : "item-mobile-inactive";
  const { userInfo } = useAppSelector((state) => state.auth);

  if (!userInfo?.groups.includes("admin") && adminItems.includes(href))
    return null;
  if (!userInfo?.is_validated && validatedItems.includes(href)) return null;

  return (
    <Link to={href}>
      <ListItem
        className={`${activeClasses} text-center mx-auto w-full cursor-pointer`}
      >
        {mobile ? (
          <Tooltip title={label} className={activeMobileClasses}>
            <div>{icon}</div>
          </Tooltip>
        ) : (
          <>
            <ListItemPrefix>{icon}</ListItemPrefix>
            <span>{label}</span>
          </>
        )}
      </ListItem>
    </Link>
  );
};
